module.exports = __webpack_public_path__ + "img/pr-29.ea5d5ba1.png";